import { defineStore } from 'pinia'

export const useFiltersStore = defineStore('filters', {
    state: () => ({
        keyword:       '',
        sortBy:        'popular',
        sortOptions:   [
            { value: 'popular',  label: 'Most Popular' },
            { value: 'newest',   label: 'Newest' },
            { value: 'alphabet', label: 'Alphabetical' },
        ],
        filtersHidden: false,
        filterGroups:  window.OptimizeTemplates.filter_groups,
    }),
    getters: {
        selectedFilters() {
            let selected = []

            // Collect selected tags
            this.filterGroups.forEach(group => {
                group.filters.forEach(filter => {
                    if (filter.checked) {
                        selected.push({
                            filter: filter,
                            group: { id: group.id, title: group.title, title_singular: group.title_singular }
                        })
                    }
                })
            })

            return selected
        }
    },
    actions: {
        refreshFilters() {
            // The count of templates could be a problem here
            // So in the future we need to re-fetch the filters from the SL
            this.filterGroups = window.OptimizeTemplates.filter_groups
        },
    }
})
